// src/ThankYouPage.js
import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import myLogo from "../../Assets/Logo/NYC-Logo.png";
import '../../css/Cart/ThankYouPage.css';
import { Link } from 'react-router-dom';
import { useCartInventoryContext } from '../../../Context/Cache/CartInventoryContext';
 
const ThankYouPage = () => {
  const { setDisplayThankYouPage, ownerInfo } = useCartInventoryContext()
  const handleCloseThankyou = () => {
    setDisplayThankYouPage(false)
  }
  const validSalesPerson = localStorage.getItem('validSalesPerson') === 'true';
const validNewUser = localStorage.getItem('newCustomer') === 'true';

let ownerFullName = "";
let ownerEmail = "";

if (!validSalesPerson && validNewUser) {
  ownerFullName = ownerInfo[0]?.yomifullname || "";
  ownerEmail = ownerInfo[0]?.domainname || "";
} else {
  ownerFullName = ownerInfo?.yomifullname || "";
  ownerEmail = ownerInfo?.domainname || "";
}


  return (
    <div className="thank-you-container">
      <div className="thank-you-content flex flex-col">
        <div className='flex justify-center'>
          <img src={myLogo} alt="Thank You" className="thank-you-image w-1/2" />
        </div>
        <div className="thank-you-header">
          <h1 className='thankYou-h1'>Thank You!</h1>
          {/* <FaCheckCircle className="thank-you-icon" /> */}
        </div>
        <p className="paragraph">
          Your Offer has been submitted and will be reviewed by the Sales Representative, {ownerFullName} ({ownerEmail}).
          Refer to Recent Offers/Order for updates.
        </p>
        <Link to={"/home/inventory"}><button className="back-to-home" onClick={handleCloseThankyou}>Back to Inventory</button></Link>
      </div>
    </div>
  );
};
 
export default ThankYouPage;